__turbopack_context__.v({
  "ripple": "ripple-module__GjVQyG__ripple",
  "ripple-dark": "ripple-module__GjVQyG__ripple-dark",
  "ripple-light": "ripple-module__GjVQyG__ripple-light",
  "ripple-release": "ripple-module__GjVQyG__ripple-release",
});
